import { getGroupIdFromTableQuery } from 'owa-group-common';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { select } from 'satcheljs/lib/legacy';
/**
 * Get all the table views that may contain items from the given group
 * @param the group id
 * @param shouldIncludeSearchTable - whether to include the search table in the table list being returned
 * @param the GetAllTableViewsContainingItemsForGroupState used for getAllTableViews
 */
export default select({
    tableViews: function () { return listViewStore.tableViews; },
})(function getAllTableViewsContainingItemsForGroup(groupId, shouldIncludeSearchTable, state) {
    var tableViews = state.tableViews;
    var allTableViewsOfGroup = [];
    tableViews.forEach(function (tableView) {
        // Include search table if specified
        if (getGroupIdFromTableQuery(tableView.tableQuery) == groupId ||
            (shouldIncludeSearchTable && tableView.tableQuery.type == 1 /* Search */)) {
            allTableViewsOfGroup.push(tableView);
        }
    });
    return allTableViewsOfGroup;
});
//# sourceMappingURL=getAllTableViewsContainingItemsForGroup.js.map